import React, { lazy } from 'react';
import { Switch } from 'react-router-dom';
import PrivateRoute from '../../components/PrivateRoute';
import retry from '../../retry';

const AgendamentosTccPage = lazy(() =>
  retry(() => import('./AgendamentosTccPage'))
);

export default () => (
  <Switch>
    <PrivateRoute
      exact
      path="/agendamentos-tcc"
      component={AgendamentosTccPage}
    />
  </Switch>
);
